module.exports = "/assets/landing-rc/promo/kinley-photo@2x.jpg?wdBH86o";